import { imageLoader } from "@/lib/sanity/client";
import Image from "next/image";
import React, { useState } from "react";
import { Wrapper } from "./styles";

export type ImageProps = {
  asset?: {
    url?: string;
    metadata?: {
      dimensions?: {
        width: number;
        height: number;
      };
    };
  };
  alt?: string;
};

const Thumbnail: React.FC<{ image: ImageProps }> = ({ image }) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  return (
    <Wrapper $hasLoaded={loaded}>
      {image?.asset && image?.asset?.url && (
        <Image
          src={image?.asset?.url}
          layout="responsive"
          alt={image?.alt || ""}
          width={image?.asset?.metadata?.dimensions?.width}
          height={image?.asset?.metadata?.dimensions?.height}
          loader={imageLoader}
          onLoadingComplete={() => setLoaded(true)}
          priority
          quality={100}
        />
      )}
    </Wrapper>
  );
};

export default Thumbnail;
